import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './core/core.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import {MatIconModule} from "@angular/material/icon";
import { CommonModule } from '@angular/common';
import {ToastrModule} from "ngx-toastr";
import {QuillModule} from "ngx-quill";
import { LayoutModule } from '@angular/cdk/layout';
import {DragDropModule} from "@angular/cdk/drag-drop";

@NgModule({
    declarations: [AppComponent],
    imports: [
        DragDropModule,
        BrowserModule,
        CommonModule,
        IonicModule.forRoot(),
        AppRoutingModule,
        BrowserAnimationsModule,
        HttpClientModule,
        CoreModule,
        LayoutModule,
        ToastrModule.forRoot(),
        QuillModule.forRoot({
            modules: {
                toolbar: {
                    container: [
                        ['bold', 'italic'],
                        [{
                            'color': ['#F00', '#0F0', '#00F', '#000', 'color-picker']
                        }],
                        [{
                            'background': ['transparent','#F00', '#0F0', '#00F', '#000', '#FFF', 'background-picker']
                        }],
                        [{align: []}],
                        ['small', 'normal', 'large', 'huge', 'extra-huge', 'extra-extra-huge'],
                        [{font: ['arial', 'serif', 'roboto']}],
                    ]
                },
            }
        }),
        MatIconModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        })
    ],
    providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }],
    bootstrap: [AppComponent]
})
export class AppModule {}
